import { render, staticRenderFns } from "./filepreview.vue?vue&type=template&id=4d7b64c7"
import script from "./filepreview.vue?vue&type=script&lang=js"
export * from "./filepreview.vue?vue&type=script&lang=js"
import style0 from "./filepreview.vue?vue&type=style&index=0&id=4d7b64c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports